import classNames from 'classnames';

import InternalImage from '../../../app/shared/components/Image/Image';
import placeholder from '../../../images/pricelists/imagePlaceholder.svg';
import css from './Image.css';

interface ImageProps
  extends Pick<React.ComponentProps<typeof InternalImage>, 'scalingMode' | 'sharpeningFactor' | 'size'> {
  alt: string;
  height: number;
  src: string;
  width: number;
  className?: string;
}

const Image = ({ alt, className, height, src, width, ...props }: ImageProps) => {
  return (
    <InternalImage
      className={classNames(css.root, className)}
      classNameError={css.withFallback}
      alt={alt}
      src={src}
      width={width}
      height={height}
      // `key` mounts a fresh node instead of reusing the tracked image's, whose
      // imperative onload/onerror handlers would otherwise re-fire and loop forever.
      fallback={<img className={css.placeholder} src={placeholder} alt="" key="fallback" />}
      {...props}
    />
  );
};

export default Image;
